import {
  Component,
  Directive,
  QueryList,
  ContentChild,
  ContentChildren,
  Input,
  Output,
  EventEmitter,
  NgModule,
  TemplateRef,
  ModuleWithProviders,
  AfterContentInit,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostBinding,
  Optional,
  forwardRef,
  OnChanges,
  SimpleChange,
  SimpleChanges,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { ControlValueAccessor, FormsModule } from '@angular/forms';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { LyShadowModule, LyShadowService } from 'alyle-ui/shadow';
import { CarouselService, VibrantColors } from './carousel.service';
import { Platform } from 'alyle-ui/core';
import { MinimalLS } from 'alyle-ui/ls';

@Component({
  selector: 'ly-carousel',
  styles: ["@keyframes animationIntroStart { 0% { opacity: 0; } 100% { opacity: 1; } } .ly-carousel-container { display: inherit; position: absolute; } :host { display: inline-block; } :host /deep/ { -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; position: relative; } :host /deep/ .lycarousel-slide { position: relative; overflow: hidden; width: inherit; height: inherit; } :host /deep/ .lycarousel-slide .lycarousel-items { height: inherit; width: inherit; } :host /deep/ .lycarousel-slide .lycarousel-items .lycarousel-item img { display: block; max-width: 100%; height: inherit; width: inherit; background-repeat: no-repeat; background-size: cover; background-position: 50%; background-position: center; position: absolute; } :host /deep/ .lycarousel-item { animation: 725ms animationIntroStart; height: inherit; width: inherit; -webkit-transition: -webkit-transform 0.6s cubic-bezier(0.23, 1, 0.32, 1); -o-transition: -o-transform 0.6s cubic-bezier(0.23, 1, 0.32, 1); transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1); -webkit-backface-visibility: hidden; backface-visibility: hidden; -webkit-perspective: 1000px; perspective: 1000px; display: none; position: relative; -webkit-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1) left; -o-transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1) left; transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1) left; } :host /deep/ .lycarousel-item.active { display: block; left: 0; } :host /deep/ .lycarousel-content { position: absolute; top: 0; bottom: 0; left: 0; right: 0; width: 100%; height: 100%; } :host /deep/ .lycarousel-cursor-left, :host /deep/ .lycarousel-cursor-right { position: absolute; top: 0; bottom: 0; width: 50%; } :host /deep/ .lycarousel-cursor-left { background: transparent; left: 0; cursor: url(\"data:image/png;base64,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\"), default !important; } :host /deep/ .lycarousel-cursor-right { background: transparent; right: 0; cursor: url(\"data:image/png;base64,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\"), default !important; } :host /deep/ svg { height: 0; width: 0; position: absolute; } :host /deep/ .carousel-indicators-container { z-index: 1; height: 48px; width: 100%; overflow: hidden; position: absolute; bottom: 0; } :host /deep/ .carousel-blur { height: 200px; width: 100%; overflow: hidden; transform: translate(0px, 0px); position: absolute; background-size: cover; background-position: center; bottom: 0; filter: blur(60px); -webkit-filter: blur(60px) !important; -moz-filter: blur(60px); -o-filter: blur(60px); -ms-filter: blur(60px); opacity: .75; filter: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQoJPGZpbHRlciBpZD0iYmx1ciI+DQoJCTxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjMiIC8+DQoJPC9maWx0ZXI+DQo8L3N2Zz4=#blur); filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='6'); } :host /deep/ .animation { animation: 725ms animationIntroStart; } :host /deep/ .carousel-indicators { padding: 0; z-index: 1; position: absolute; bottom: 0; width: 100%; text-align: center; margin: 0; box-sizing: border-box; background: inherit; display: flex; align-items: center; justify-content: center; height: 48px; } :host /deep/ .carousel-indicators li { display: inline-block; width: 20px; border-radius: 4px; background: #fff; height: 20px; margin: 0 4px; transform: scale(0.7); box-shadow: 0 0 10px 0 currentColor; cursor: pointer; transition: 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94); } :host /deep/ .carousel-indicators li.active { transform: scale(1); } :host /deep/ .carousel-indicators li:focus { outline: none; } :host /deep/ .carousel-indicators li:active { outline: none; } .ly-carousel-inactive-button { color: #fff !important; background: #fff !important; } "],
  template: `
  <div class="lycarousel-slide" ly-shadow [shadowColor]="lyItems.toArray()[_itemSelect]?.color?.DarkMuted?.hex || '#fff'" scale="2">
    <!--buttons-->
    <div class="carousel-indicators-container animation">
      <div class="carousel-blur" [style.background-image]="'url('+lyItems.toArray()[_itemSelect]?.src+')'"></div>
    </div>
    <ul class="carousel-indicators" *ngIf="lyItems.length!=1">
      <li tabindex="0"
      (click)="select(i)"
      role="button"
      [class.active]="_itemSelect==i"
      [style.background-color]="item.color.Vibrant?.hex"
      [style.color]="item.color.DarkVibrant?.hex"
      [class.ly-carousel-inactive-button]="!(_itemSelect == i)"
      *ngFor="let item of lyItems; let i = index"></li>
    </ul>
    <!--items-->
    <div class="lycarousel-items" [style.background-color]="lyItems.toArray()[_itemSelect]?.color?.DarkVibrant?.hex">
      <div [class.active]="_itemSelect==i"
      class="lycarousel-item"
      *ngFor="let item of lyItems; let i = index">
        <img [src]="nullImg"
        [style.background-image]="'url('+item.src+')'">
      </div>
      <!--<div class="lycarousel-content">
      <ng-content></ng-content>
      </div>-->
    </div>
    <!--cursor-->
  </div>
  <div class="lycarousel-content ly-carousel-container">
    <ng-content></ng-content>
  </div>
  <div *ngIf="lyItems.length!=1" (click)="focusLeft()" class="lycarousel-cursor-left"></div>
  <div *ngIf="lyItems.length!=1" (click)="focusRight()" class="lycarousel-cursor-right"></div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class LyCarousel implements ControlValueAccessor, AfterViewInit, OnDestroy {
  public data: any;
  public value: any;
  public _selectedIndex: any;
  public _interval = 2000;
  public _fnInterval: any;
  public _isInitialized = false;
  public nullImg = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
  @ContentChildren(forwardRef(() => LyCarouselItemComponent)) lyItems: QueryList<LyCarouselItemComponent>;
  _itemSelect = 0;
  currentCarousel: LyCarouselItemComponent;
  currentColors: VibrantColors;
  /** Callback registered via registerOnTouched (ControlValueAccessor) */
  private _onTouchedCallback: () => void;

  /** Callback registered via registerOnChange (ControlValueAccessor) */
  private _onChangeCallback: (_: any) => void;
  constructor(
    private elementRef: ElementRef,
    private shadow: LyShadowService,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }
  private sanitizerStyle(val: any): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(val);
  }
  @Input('interval')
  public get interval(): number { return this._interval; }
  public set interval(value: number) {
    this._interval = value;
  }

  public registerOnChange(fn: any) {
    this._onChangeCallback = fn;
  }
  public get stateIndicator() {
    if (this.lyItems === undefined) {
      return 0;
    } else {
      const st = (this._itemSelect + 1) * 100 / this.lyItems.length;
      return st;
    }
  }
  public get stylesBar() {
    const bar = this.elementRef.nativeElement.querySelector('._bar');
    // bar.style.animation = `none`;
    return {
      animation: `none`
    };
  }

  public registerOnTouched(fn: any) {
    this._onTouchedCallback = fn;
  }

  public writeValue(value: any) {
    // nothing
  }

  public ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      clearInterval(this._fnInterval);
    }
  }
  public _intervalCarousel(value: any = '+') {
    if (isPlatformBrowser(this.platformId)) {
      if (value === '+') {
        this._itemSelect++;
        this._itemSelect = (this._itemSelect === (this.lyItems.length) ? 0 : this._itemSelect);
        // console.log(this._itemSelect, this.lyItems.length);
      } else if (value === '-') {
        this._itemSelect--;
        this._itemSelect = (this._itemSelect <= -1 ? (this.lyItems.length - 1) : this._itemSelect--);
        // console.log('--',this._itemSelect, this.lyItems.length);
      } else {
        this._itemSelect = value;
      }
      const intrval$ = {
        interval$: setInterval(() => {
          this._itemSelect++;
          this._itemSelect = (this._itemSelect === (this.lyItems.length) ? 0 : this._itemSelect++);
          // console.log('interval state', this._itemSelect);
          this.setActiveItem();
        }, this._interval)
      };
      clearInterval(this._fnInterval);
      this._fnInterval = intrval$.interval$;
      this.setActiveItem();
    }
  }
  setActiveItem() {
    // let activeItems = this.lyItems.filter((tab)=>tab.active);
    Promise.resolve(null).then(() => {
      const controlsBottom = this.elementRef.nativeElement.querySelector('.carousel-indicators-container');
      controlsBottom.classList.remove('animation');
      // tslint:disable-next-line:no-unused-expression
      void controlsBottom.offsetWidth;
      controlsBottom.classList.add('animation');
      this.lyItems.forEach((_item: LyCarouselItemComponent) => {
        _item.lyCarouselActive = false;
        _item._markForCheck();
      });
      const item = this.lyItems.find((a: LyCarouselItemComponent, b: number) => b === this._itemSelect);
      this.currentCarousel = item;
      this.currentColors = item.color;
      item.lyCarouselActive = true;
      this.cd.markForCheck();
    });
  }

  _markForCheck() {
    this.cd.markForCheck();
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this._intervalCarousel(0);
      this.lyItems.changes.subscribe((carousel: LyCarouselItemComponent) => {
        this._itemSelect = 0;
        this._intervalCarousel(0);
        this.setActiveItem();
        this.cd.markForCheck();
      });
    }
  }
  public select(val: number) {
    this._intervalCarousel(val);
  }
  public focusRight() {
    this._intervalCarousel('+');
  }
  public focusLeft() {
    this._intervalCarousel('-');
  }
}

@Component({
  selector: 'ly-carousel-item',
  styles: [`
    :host:not(.ly-carousel-item-active) {
      display: none !important;
    }
  `],
  template: `
  <ng-template [ngIf]="lyCarouselActive">
    <ng-content></ng-content>
  </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LyCarouselItemComponent implements OnInit, OnChanges {
  @Input('src') src: string;
  @Input('lyCarouselActive') @HostBinding('class.ly-carousel-item-active') lyCarouselActive = false;
  color: VibrantColors = new VibrantColors;
  private _carousel: LyCarousel;

  constructor(
    @Optional() carousel: LyCarousel,
    private carouselService: CarouselService,
    private ls: MinimalLS,
    private cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this._carousel = carousel;
  }

  preloadImage(url) {
    if (url === null || url === 'null') {
      return;
    }
    try {
      const img = new Image();
      img.src = url;
    } catch (e) { }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['src']) {
      if (!changes['src'].firstChange) {
        this.updateColors();
      }
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.preloadImage(this.src);
      this.updateColors();
    }
  }
  updateColors() {
    if (Platform.isBrowser) {
      if (this.src === null || this.src === 'null') {
        return;
      } else {
        if (this.ls.hasItem(this.src)) {
          this.color = this.ls.item(this.src);
          this._carousel._markForCheck();
        } else {
          const colorV = this.carouselService.getColorVibrant(this.src);
          colorV.then((p: any) => {
            this.color = this.carouselService._palette(p);
            this._carousel._markForCheck();
            this._markForCheck();
          });
        }
      }
    }
  }
  _markForCheck() {
    this.cd.markForCheck();
  }
}
